import AddProductScreen from "../modules/product/AddProductScreen";

export default function AddProduct() {
  return (
    <>
      <AddProductScreen />
    </>
  )
}
